import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 13,
	viewBox: "0 0 8 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 11.5L6 6.5L1 1.5",
		stroke: "#79c912",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgChevronRight;
